import focus from "@alpinejs/focus";
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import Alpine from "alpinejs";
import accordion from "@/ts/modules/common/accordion";
import dropdownMenu from "@/ts/modules/common/dropdownMenu";
import mobileNavigation from "@/ts/modules/common/mobileNavigation";
import setCssVariable from "@/ts/modules/common/setCssVariable";
import tab from "@/ts/modules/common/tab";
import toggleHeaderColor from "@/ts/modules/common/toggleHeaderColor";

Alpine.plugin(focus);

window.Alpine = Alpine;
Alpine.data("mobileNavigation", mobileNavigation);
Alpine.start();

setCssVariable();

const accordionTrigger = Array.from(
	document.querySelectorAll<HTMLButtonElement>("[data-accordion]"),
);
if (accordionTrigger.length > 0) accordion(accordionTrigger);

const dropdownMenuTrigger = Array.from(
	document.querySelectorAll<HTMLButtonElement>("[data-dropdown]"),
);
if (dropdownMenuTrigger.length > 0) dropdownMenu(dropdownMenuTrigger);

const moveImage = document.getElementById("move-image");
if (moveImage !== null) {
	const infoIntersectionObserver = new IntersectionObserver(
		(entries: IntersectionObserverEntry[], _observer: IntersectionObserver) => {
			for (const entry of entries) {
				if (entry.isIntersecting) {
					(entry.target as HTMLElement).classList.add("show");
					_observer.unobserve(entry.target);
				}
			}
		},
		{
			root: null,
			rootMargin: "-10% 0px",
			threshold: 0,
		},
	);

	infoIntersectionObserver.observe(moveImage);
}

const tabs = document.querySelectorAll<HTMLElement>('[role="tab"]');
if (tabs.length > 0) tab(tabs);

const siteHeader = document.getElementById("site-header");
if (siteHeader !== null) {
	toggleHeaderColor({
		target: siteHeader,
		className: "scrolled",
		threshold: 100,
	});
}

const fvSlider = document.getElementById("fv-slider");
if (fvSlider !== null) {
	new Splide("#fv-slider", {
		type: "fade",
		rewind: true,
		autoplay: true,
		arrows: false,
		pagination: false,
		interval: 5000,
		speed: 3000,
	}).mount();
}

const pickupSlider = document.getElementById("pickup-slider");
if (pickupSlider !== null) {
	new Splide("#pickup-slider", {
		type: "slide",
		arrows: true,
		pagination: false,
		speed: 500,
		fixedWidth: 250,
		gap: 32,
		mediaQuery: "min",
		breakpoints: {
			1024: {
				fixedWidth: 350,
			},
		},
	}).mount();
}

const leadSlider = document.querySelector(".lead-slider");
if (leadSlider !== null) {
	new Splide(".lead-slider", {
		type: "loop",
		arrows: true,
		pagination: true,
		speed: 500,
		heightRatio: 0.6161,
		gap: 1,
	}).mount();
}

const lifeBgSlider = document.getElementById("life-bg-slider");
if (lifeBgSlider !== null) {
	new Splide("#life-bg-slider", {
		type: "fade",
		rewind: true,
		autoplay: true,
		arrows: false,
		pagination: false,
		interval: 5000,
		speed: 3000,
	}).mount();
}

const facilitySlider = document.getElementById("facility-slider");
if (facilitySlider !== null) {
	new Splide("#facility-slider", {
		type: "loop",
		drag: false,
		focus: "center",
		arrows: false,
		pagination: false,
		autoScroll: {
			speed: 0.5,
			rewind: false,
			pauseOnFocus: false,
			pauseOnHover: false,
		},
		fixedWidth: 300,
		mediaQuery: "min",
		breakpoints: {
			768: {
				fixedWidth: 500,
			},
		},
	}).mount({ AutoScroll });
}

const homeFacilitySlider = document.querySelector(".home .facility-slider");
if (homeFacilitySlider !== null) {
	new Splide(".home .facility-slider", {
		type: "loop",
		drag: false,
		focus: "center",
		arrows: false,
		pagination: false,
		autoScroll: {
			speed: 0.7,
			rewind: false,
			pauseOnFocus: false,
			pauseOnHover: false,
		},
		autoWidth: true,
	}).mount({ AutoScroll });
}

const institutionSlider = document.querySelector(".institution-slider");
if (institutionSlider !== null) {
	new Splide(".institution-slider", {
		type: "loop",
		autoplay: true,
		arrows: false,
		pagination: true,
		speed: 500,
		heightRatio: 0.6161,
		gap: 1,
	}).mount();
}


function scroll_effect() {
  var element = document.getElementsByClassName('scroll-up');
  if(!element) return;
                      
  var scrollY = window.pageYOffset;
  var windowH = window.innerHeight;
  var showTiming = 200; // 要素を表示するタイミング
  for(var i = 0; i < element.length; i++) { 
    var elemClientRect = element[i].getBoundingClientRect(); 
    var elemY = scrollY + elemClientRect.top; 
    if(scrollY > elemY - windowH + showTiming) {
      element[i].classList.add('is-show');
    }
  }
}
window.addEventListener('scroll', scroll_effect); // スクロール時に実行

function anime_effect() {
  var element = document.getElementsByClassName('track');
  if(!element) return;
                      
  var scrollY = window.pageYOffset;
  var windowH = window.innerHeight;
  var showTiming = 200; // 要素を表示するタイミング
  for(var i = 0; i < element.length; i++) { 
    var elemClientRect = element[i].getBoundingClientRect(); 
    var elemY = scrollY + elemClientRect.top; 
    if(scrollY > elemY - windowH + showTiming) {
      element[i].classList.add('is-show');
    }
  }
}
window.addEventListener('scroll', anime_effect); // スクロール時に実行

// 背景画像の自動切り替え
        const bgImages = document.querySelectorAll('.bg-image');
        let currentIndex = 0;

        function changeBackground() {
            // 現在の画像を非表示
            bgImages[currentIndex].classList.remove('active');
            
            // 次の画像のインデックスを計算
            currentIndex = (currentIndex + 1) % bgImages.length;
            
            // 次の画像を表示
            bgImages[currentIndex].classList.add('active');
        }

        // 5秒ごとに背景画像を切り替え
        setInterval(changeBackground, 5000);
				